import { useObservableEagerState } from "observable-hooks";
import { useClientEnvironment } from "~/environment/ClientEnvironmentContext";

export function useIsServiceWorkerUpdateAvailable() {
  const environment = useClientEnvironment();
  return useObservableEagerState(environment.serviceWorker.isUpdateAvailable$);
}
